/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} View_All_SeedsInputs */

const en_view_all_seeds = /** @type {(inputs: View_All_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View All Seeds`)
};

const th_view_all_seeds = /** @type {(inputs: View_All_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูเมล็ดพันธุ์ทั้งหมด`)
};

const ja_view_all_seeds = /** @type {(inputs: View_All_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのシードを見る`)
};

const fr_view_all_seeds = /** @type {(inputs: View_All_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir toutes les graines`)
};

const es_view_all_seeds = /** @type {(inputs: View_All_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todas las semillas`)
};

const ru_view_all_seeds = /** @type {(inputs: View_All_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть все семена`)
};

const zh_view_all_seeds = /** @type {(inputs: View_All_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看全部种子`)
};

const vi_view_all_seeds = /** @type {(inputs: View_All_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem tất cả hạt giống`)
};

/**
* | output |
* | --- |
* | "View All Seeds" |
*
* @param {View_All_SeedsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const view_all_seeds = /** @type {((inputs?: View_All_SeedsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<View_All_SeedsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_view_all_seeds(inputs)
	if (locale === "ja") return ja_view_all_seeds(inputs)
	if (locale === "fr") return fr_view_all_seeds(inputs)
	if (locale === "es") return es_view_all_seeds(inputs)
	if (locale === "ru") return ru_view_all_seeds(inputs)
	if (locale === "zh") return zh_view_all_seeds(inputs)
	if (locale === "vi") return vi_view_all_seeds(inputs)
	return en_view_all_seeds(inputs)
});